export default __webpack_public_path__ + "static/media/logo.62da97b8.png";